module.exports = __webpack_public_path__ + "img/header_bg.53167f53.png";